/*
 * Talon Algo theme script. Small on purpose (budget: 10 KB). No dependencies.
 * Everything on the site works with this file absent: the menu and the FAQ are
 * native <details>, links are plain <a>.
 *
 * 1. Theme toggle (dark default, choice stored per visitor).
 * 2. Menu: Escape, a click outside it or a click on one of its links closes it.
 * 3. "Privacy choices" reopens Shopify's consent banner.
 * 4. Analytics events (W5/02 section 10): published to Shopify's pixel
 *    sandbox with Shopify.analytics.publish, only when events are switched on
 *    in theme settings and the visitor's consent allows analytics. No personal
 *    data is ever sent: only enum values from data attributes.
 * 5. Reveal: one 8 px fade-up as a band enters (never under reduced motion).
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var cfg = window.TalonTheme || {};

  /* ---- 1. Theme toggle ---- */
  var toggle = document.querySelector('[data-theme-toggle]');
  function syncToggle() {
    if (!toggle) return;
    toggle.setAttribute('aria-pressed', root.getAttribute('data-theme') === 'light' ? 'true' : 'false');
  }
  if (toggle) {
    syncToggle();
    toggle.addEventListener('click', function () {
      var next = root.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
      root.setAttribute('data-theme', next);
      try { localStorage.setItem('talon-theme', next); } catch (e) { /* storage blocked: choice lasts for this page only */ }
      syncToggle();
    });
  }

  /* ---- 2. Menu ---- */
  var menu = document.querySelector('[data-menu]');
  if (menu) {
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        var summary = menu.querySelector('summary');
        if (summary) summary.focus();
      }
    });
    document.addEventListener('click', function (event) {
      if (menu.open && (!menu.contains(event.target) || (event.target.closest && event.target.closest('nav a')))) menu.open = false;
    });
  }

  /* ---- 2b. Contents list on long pages: open beside the text on wide screens ---- */
  var toc = document.querySelector('[data-toc]');
  if (toc && window.matchMedia && window.matchMedia('(min-width: 1101px)').matches) toc.open = true;

  /* ---- 3. Privacy choices ---- */
  var privacyButtons = document.querySelectorAll('[data-privacy-choices]');
  Array.prototype.forEach.call(privacyButtons, function (button) {
    button.addEventListener('click', function () {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else if (cfg.privacyUrl) {
        window.location.href = cfg.privacyUrl;
      }
    });
  });

  /* ---- 4. Analytics events ---- */
  var debug = /[?&]debug_events=1(&|$)/.test(window.location.search);

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.analyticsProcessingAllowed === 'function') {
        return privacy.analyticsProcessingAllowed();
      }
    } catch (e) { /* fall through */ }
    return false; /* no consent API, no events */
  }

  function publish(name, props) {
    var payload = props || {};
    payload.mode = cfg.mode || 'staging';
    if (cfg.siteId) payload.site_id = cfg.siteId;
    if (debug && window.console) console.log('[talon event]', name, payload);
    if (!cfg.events || !analyticsAllowed()) return;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* never break the page for analytics */ }
  }

  function propsFrom(el) {
    var props = {};
    ['placement', 'plan', 'ctaId', 'destType', 'target', 'network', 'faqId'].forEach(function (key) {
      if (el.dataset[key]) props[key.replace(/[A-Z]/g, function (c) { return '_' + c.toLowerCase(); })] = el.dataset[key];
    });
    return props;
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest ? event.target.closest('[data-event]') : null;
    if (!el || el.tagName === 'DETAILS') return;
    publish(el.dataset.event, propsFrom(el));
  });

  Array.prototype.forEach.call(document.querySelectorAll('details[data-event="faq_expand"]'), function (item) {
    item.addEventListener('toggle', function () {
      if (item.open) publish('faq_expand', propsFrom(item));
    });
  });

  if (cfg.pageEvent) publish(cfg.pageEvent, cfg.pageEventProps || {});

  if ('IntersectionObserver' in window) {
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        seen.unobserve(entry.target);
        publish('trial_terms_view', { placement: entry.target.dataset.placement || 'unknown' });
      });
    }, { threshold: 0.5 });
    Array.prototype.forEach.call(document.querySelectorAll('[data-terms]'), function (block) { seen.observe(block); });
  }

  /* ---- 5. Reveal once ---- */
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !still) {
    var rv = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        rv.unobserve(entry.target);
        entry.target.classList.add('rv-in');
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    Array.prototype.forEach.call(document.querySelectorAll('main .band > .wrap, main .cta-band .wrap'), function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) return; /* already on screen: never hide it */
      el.classList.add('rv');
      rv.observe(el);
    });
  }
})();
